// extracted by mini-css-extract-plugin
export default {"body":"confirm_body__+b+fF"};